import { postMethod } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS';
export const SET_PASSWORD_FAILURE = 'SET_PASSWORD_FAILURE';

// Action Creators
export const setPassword = () => ({
  type: SET_PASSWORD,
});

export const setPasswordSuccess = (data) => ({
  type: SET_PASSWORD_SUCCESS,
  payload: data,
});

export const setPasswordFailure = (error) => ({
  type: SET_PASSWORD_FAILURE,
  payload: error,
});

// Thunk Function
export const setPasswordCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(setPassword());
    try {
      const response = await postMethod(url.setPassword, data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(setPasswordSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        dispatch(setPasswordFailure(response?.data));
        if (external?.error === true) {
          external?.handleErrorFunction(response?.data);
        }
      }
    } catch (error) {
      dispatch(setPasswordFailure(error?.message));
    }
  };
};
